/**
 * Master v5 Prompt 28 — a global "you're offline" banner for the
 * Rehearsal Room SPA. The service worker's offline.html fallback only
 * covers a full-page navigation with no network at all; a user who
 * loses connectivity WHILE already inside the app (no page reload)
 * previously got silent, confusing fetch failures with no indication
 * why. Mounted once at the app shell level, same pattern as
 * ViewAsBanner — pure client-side `navigator.onLine` + the browser's
 * own `online`/`offline` events, no polling, no new dependency.
 */
import { useEffect, useState } from "react";

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!isOffline) return null;
  return (
    <div
      className="sticky top-0 z-[60] bg-terracotta text-white text-xs sm:text-sm text-center py-1.5 px-3"
      data-testid="offline-banner"
    >
      You're offline. Changes will not save until your connection is back.
    </div>
  );
}
